const version = {
  major: 4,
  minor: 4,
  patch: 3
};
export {
  version
};
//# sourceMappingURL=index156.js.map
